import styled, { css } from 'styled-components';
export const Container = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;

  ${({ $marginTop }) => $marginTop &&
    css `
      margin-top: ${$marginTop};
    `};

  ${({ $marginBottom }) => $marginBottom &&
    css `
      margin-bottom: ${$marginBottom};
    `};
`;
export const Divider = styled.div `
  flex: 1;
  height: 1px;

  background: var(--border-tertiary);
`;
export const Label = styled.div `
  padding: 0 var(--space-300);
  font-size: var(--font-size-300);
  font-style: normal;
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-300);
  letter-spacing: var(--font-letter-spacing-loose);
  color: var(--text-secondary);
`;
